import maskedInputComponent from './maskedInput.component';
import maskedInputFactory from './maskedInput.factory';

const maskedInput = angular.module('app.common.ertMaskedInput', [])
	.factory('maskedInputService', maskedInputFactory)
	.component('ertMaskedInput', maskedInputComponent)
	.name;

export default maskedInput;
